import { IDataStorage } from '../internal/data-storage';
import { InternalTable } from '../internal/internal-table';
import { InternalIndex } from '@stockcare-storage/internal/internal-index';

export class Stock implements IDataStorage {
  barcodeIndex: InternalIndex = new InternalIndex(
    'barcode',
    'barcode',
    true,
    false
  );
  tableDefinition: InternalTable = new InternalTable(
    'Stock',
    'stockLevelId',
    true,
    [this.barcodeIndex]
  );

  stockLevelId: number;
  materialId: number;
  name: string;
  unitOfMeasure: string;
  barcode: string;
  isBOM: boolean;
  quantity: number;
  category: string;
  icon: string;
  stockLocationId: number;

  static getTableDefinition(): InternalTable {
    return new Stock().tableDefinition;
  }
}
